export const POLICIES_TEXT = `
<h1>Acceptable Use Policy</h1>

<p><strong>Effective Date:</strong> January 1, 2026<br />
<strong>Policy Owner:</strong> kyu Operations Team</p>

<h2>1. Purpose</h2>
<p>
  This Policy governs use of the kyu OS’ BD100 Collaboration Hub Platform ("Platform") by authorized users of kyu Collective member companies.
  The Platform facilitates business development collaboration and RFP information sharing across the kyu network.
</p>

<h2>2. Confidentiality</h2>
<p>
  All information on the Platform is confidential and must be treated as such, whether or not it is marked "confidential."
  This includes RFP documents, pricing, proposals, client information, teaming strategies, and any other non-public information
  shared through the Platform (<strong>“Confidential Information”</strong>).
</p>
<p>
  For the avoidance of doubt, Confidential Information includes the fact that a client has issued, or is considering issuing,
  an RFP, engaging in a pitch process, or pursuing a specific business initiative, whether or not related documents are shared on the Platform.
</p>
<p>Your use of Platform information is subject to:</p>
<ul>
  <li>The confidentiality obligations in your employment agreement or other agreement with your employer; and</li>
  <li>The kyu Collective Confidentiality Agreement between kyu member companies, which governs how your employer handles information shared across the kyu network.</li>
</ul>

<h2>3. Permitted Use</h2>
<p>Use Platform information only for kyu Collective collaboration purposes, including:</p>
<ul>
  <li>Evaluate and identify opportunities to collaborate on business development pitches</li>
  <li>Developing joint proposals</li>
  <li>Coordinating on shared client pursuits</li>
</ul>
<p>
  Do not use Platform information for any purpose unrelated to kyu collaboration, including personal benefit or activities outside the scope of your role.
</p>

<h2>4. No External Sharing</h2>
<p>Do not share Platform information with anyone outside the kyu Collective network, including:</p>
<ul>
  <li>Clients, unless authorized as part of an approved proposal submission</li>
  <li>Vendors, subcontractors, or consultants not bound by appropriate confidentiality agreements</li>
  <li>Former colleagues, personal contacts, or any unauthorized third party</li>
</ul>
<p>
  If you are unsure whether a disclosure is permitted, contact
  <a href="mailto:operations@kyu.com">operations@kyu.com</a> before sharing.
</p>

<h2>5. Access</h2>
<p><strong>Need-to-Know.</strong> Access only information relevant to projects you are actively working on. Do not browse or download information unrelated to your current responsibilities.</p>
<p><strong>Credential Security.</strong> Your login credentials are personal to you. Do not share them or allow others to access the Platform using your account.</p>

<h2>6. Offboarding</h2>
<p>
  When your access ends—whether due to a change in role, departure from your company, or completion of a project—do not retain copies of Platform information.
  Your access will be revoked, and you remain bound by confidentiality obligations after your access terminates.
</p>

<h2>7. Report Issues</h2>
<p>
  If you become aware of any unauthorized access, disclosure, or misuse of Platform information,
  notify the kyu Operations team at
  <a href="mailto:operations@kyu.com">operations@kyu.com</a> immediately.
</p>

<h2>8. Compliance</h2>
<p>
  Violation of this Policy may result in revocation of Platform access, disciplinary action by your employer,
  and potential legal consequences under the kyu Collective Confidentiality Agreement and applicable law.
</p>

<p><strong>
  BY ACCESSING THE PLATFORM, YOU ACKNOWLEDGE YOU HAVE READ THIS POLICY AND AGREE TO COMPLY WITH ITS TERMS,
  CONSISTENT WITH YOUR CONFIDENTIALITY OBLIGATIONS TO YOUR EMPLOYER AND THE AGREEMENTS GOVERNING THE KYU COLLECTIVE NETWORK.
</strong></p>
`;
